<template>
  <v-dialog
    v-model="dialog"
    max-width="900"
    style="overflow: hidden !important"
  >
    <v-card>
      <v-card-title>
        {{
          bankInstallmentList == []
            ? `${bankInstallment.name} Taksit Oluştur`
            : `${bankInstallment.name} Taksit Düzenle`
        }}
        <v-spacer></v-spacer>
        <v-btn
          @click="closeDialog()"
          color="danger darken-1"
          style="color: white"
        >
          KAPAT
        </v-btn>
      </v-card-title>
      <v-card-text>
        <div class="container">
          <v-data-table
            hide-default-footer
            :headers="bankInstallmentListHeaders"
            :items="bankInstallment.installments"
            class="elevation-1"
            fixed-header
          >
            <v-divider inset></v-divider>
            <template v-slot:item.isActive="{ item }">
              <span
                v-if="item.isActive === true"
                style="
                  height: 15px;
                  width: 15px;
                  background-color: #04aa6b;
                  border-radius: 50%;
                  display: inline-block;
                "
              ></span>
              <span
                v-if="item.isActive === false"
                style="
                  height: 15px;
                  width: 15px;
                  background-color: #dd1e34;
                  border-radius: 50%;
                  display: inline-block;
                "
              ></span>
            </template>

            <template v-slot:item.installmentRate="{ item }">
              <v-text-field
                v-model="editedItem.installmentRate"
                :hide-details="true"
                dense
                single-line
                class="centered-input"
                v-if="item.id === editedItem.id"
              ></v-text-field>
              <span v-else>{{ item.installmentRate }}</span>
            </template>
            <template v-slot:item.installment="{ item }">
              <v-text-field
                class="centered-input"
                v-model="editedItem.installment"
                :hide-details="true"
                dense
                single-line
                :autofocus="true"
                v-if="item.id === editedItem.id"
              ></v-text-field>
              <span v-else>{{ item.installment + "  Taksit" }}</span>
            </template>
            <template v-slot:item.actions="{ item }">
              <div v-if="item.id === editedItem.id">
                <v-icon color="red" class="mr-3" @click="closeRow">
                  mdi-window-close
                </v-icon>
                <v-icon color="green" @click="saveRow(editedItem)">
                  mdi-content-save
                </v-icon>
              </div>
              <div v-else>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="info darken-2"
                      class="mr-3"
                      @click="changeIsActive(item)"
                      v-on="on"
                    >
                      mdi-list-status
                    </v-icon>
                  </template>
                  <span>Aktiflik Değiştir</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="amber darken-2"
                      class="mr-3"
                      @click="editItem(item)"
                      v-on="on"
                    >
                      mdi-playlist-edit
                    </v-icon>
                  </template>
                  <span>Taksiti Düzenle</span>
                </v-tooltip>

                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon
                      color="danger darken-2"
                      @click="deleteItem(item)"
                      v-on="on"
                    >
                      mdi-playlist-remove
                    </v-icon>
                  </template>
                  <span>Taksiti Sil</span>
                </v-tooltip>
              </div>
            </template>
            <template v-slot:no-data>
              <div
                class="text-center mt-4 mb-4"
                v-if="bankInstallmentList.length === 0 && !editLoading"
              >
                <v-btn color="primary" @click="addNewInstallment">
                  Taksİt Ekle
                </v-btn>
              </div>
            </template>
          </v-data-table>
          <div
            v-if="bankInstallmentList.length > 0 && !editLoading"
            class="text-center mt-4"
          >
            <v-btn color="primary" @click="addNewInstallment">
              Taksİt Ekle
            </v-btn>
          </div>
        </div>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { validationMessages } from "@/validationMessages.js";

import { mapActions, mapState } from "vuex";
//import simplebar from "simplebar-vue";

export default {
  components: {
    //  simplebar
  },

  props: {
    showDialog: {
      type: Boolean,
      default: false,
    },
    bankInstallmentProp: {
      type: Object,
      default: () => ({
        id: null,
        bankCode: null,
        isActive: false,
        installments: [],
        name: "",
      }),
    },
    processType: {
      type: String,
      default: "new",
    },
  },
  computed: {
    ...mapState("bank", [
      "bankInstallmentList",
      "bankList",
      "bankInstallmentInputs",
      "bankInstallmentListHeaders",
    ]),
    ...mapState("auth", ["user"]),
  },
  mounted() {
    this.getInstallments();
  },
  data() {
    return {
      editLoading: false,
      dialog: false,
      showPassword: false,
      newInput: [],
      bankInstallment: {
        id: null,
        bankCode: null,
        isActive: false,
        installments: [
          {
            id: null,
            bankId: null,
            clientId: null,
            installment: null,
            installmentRate: null,
            isActive: false,
            isDeleted: false,
          },
        ],
        name: "",
      },
      editedIndex: -1,
      editedItem: {
        id: null,
        bankId: null,
        clientId: null,
        installment: null,
        installmentRate: null,
        isActive: false,
        isDeleted: false,
      },
      defaultItem: {
        id: null,
        bankId: null,
        clientId: null,
        installment: null,
        installmentRate: null,
        isActive: false,
        isDeleted: false,
      },
    };
  },
  methods: {
    ...mapActions("bank", [
      "fetchBankInstallmentList",
      "fetchBankInstallmentList",
      "bankInstallmentAdd",
      "bankInstallmentUpdate",
      "bankInstallmentDelete",
      "bankInstallmentActiveChange",
      "removeBankInstallments",
    ]),
    validationMessages,
    async getInstallments(item) {
      this.bankInstallment = Object.assign({}, item);
      await this.fetchBankInstallmentList(this.bankInstallment.id);
      if (this.bankInstallmentList != []) {
        this.bankInstallment.installments = this.bankInstallmentList;
      }
    },
    editItem(item) {
      this.editLoading = true;
      this.editedIndex = this.bankInstallment.installments.indexOf(item);
      this.editedItem = Object.assign({}, item);
    },
    async changeIsActive(item) {
      await this.bankInstallmentActiveChange({
        bankInstallmentId: item.id,
        value: !item.isActive,
      });
      this.$emit("installmentChange", this.bankInstallment.id);
    },
    async saveRow(item) {
      if (item.id != 999999) {
        await this.bankInstallmentUpdate({
          id: item.id,
          bankId: item.bankId,
          installment: parseInt(item.installment),
          installmentRate: parseFloat(item.installmentRate),
          isActive: item.isActive,
        });
      } else {
        await this.bankInstallmentAdd({
          bankId: item.bankId,
          installment: parseInt(item.installment),
          installmentRate: parseFloat(item.installmentRate),
          isActive: item.isActive,
        });
      }
      this.$emit("installmentChange", this.bankInstallment.id);
      this.editLoading = false;
      this.closeRow();
    },
    async deleteItem(item) {
      await this.bankInstallmentDelete(item.id);
      this.$emit("installmentChange", this.bankInstallment.id);
    },
    closeDialog() {
      this.newInput = [];
      this.dialog = false;
    },
    closeRow() {
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    async addNewInstallment() {
      this.bankInstallment.installments.push({
        id: 999999,
        bankId: this.bankInstallment.id,
        clientId: null,
        installment: null,
        installmentRate: null,
        isActive: true,
        isDeleted: false,
      });
      this.editItem({
        id: 999999,
        bankId: this.bankInstallment.id,
        clientId: null,
        installment: null,
        installmentRate: null,
        isActive: true,
        isDeleted: false,
      });
    },
    async deleteInstallment() {
      await this.bankInstallmentDelete({
        params: this.bankInstallment.id,
      });
      this.closeDialog();
    },
  },
  watch: {
    dialog: function (newVal) {
      this.$emit("dialogChange", newVal);
    },
    showDialog: function (newVal) {
      this.dialog = newVal;
    },
    bankInstallmentProp: function (newVal) {
      this.removeBankInstallments();
      this.getInstallments(newVal);
    },
  },
};
</script>
<style>
.centered-input input {
  text-align: center;
}
</style>
